import React from "react";
import GameInstructionModal from "./GameInstructionModal";

const ModalTheShooter = ({ isOpen, onRequestClose }) => {
  return (
    <GameInstructionModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      title="The Shooter"
      gamePath="/userDashboard/game/the-shooter"
      icon="icon-park-outline:game-three"
      instructions={[
        "Patch your better eye.",
        "Aim at the oncoming balls and shoot by clicking the mouse / trackpad.",
        "You can shift your position left and right using the keyboard arrow keys."
      ]}
      isBinocular={false}
    />
  );
};

export default ModalTheShooter;
